// @ts-check
import React, { Component } from "react";

/**
 * @typedef {object} props
 * @property {React.JSX.Element | string} children
 * @property {import('csstype').Property.TextWrap} [textWrap]
 * @extends {Component<props>}
 */
export class ShrinkWrap extends Component {
    /** @type {React.RefObject<HTMLDivElement | null>} */
    rootRef;

    /**
     * @param {props} props
     */
    constructor(props) {
        super(props);
        this.rootRef = React.createRef();
    }

    componentDidMount() {
        const node = this.rootRef.current;
        if (!node)
            return;

        node.style.width = "auto";
        this.shrinkWrap(node);
    }

    componentDidUpdate() {
        const node = this.rootRef.current;
        if (!node)
            return;

        node.style.width = "auto";
        this.shrinkWrap(node);
    }

    /**
     * @param {HTMLDivElement} element
     */
    shrinkWrap(element) {
        const { firstChild, lastChild } = element;
        if (!element || !firstChild || !lastChild)
            return;

        const range = document.createRange();
        range.setStartBefore(firstChild);
        range.setEndAfter(lastChild);
        const { width } = range.getBoundingClientRect();
        element.style.width = width + 1 + "px";
    };

    render() {
        return <div ref={this.rootRef} style={{ textWrap: this.props.textWrap ?? "pretty" }}>
            {this.props.children}
        </div>
    }
}

export default ShrinkWrap;